
import React,{ useEffect, setState } from 'react';
import Cookies from 'universal-cookie';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import moment from "moment";
import "moment/locale/he";
import Box from '@material-ui/core/Box';
import FormGroup from '@material-ui/core/FormGroup';
import  { Redirect } from 'react-router-dom'

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
// import MenuItem from '@material-ui/core/MenuItem';
// import Menu from '@material-ui/core/Menu';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';
// import FlagIcon from '@material-ui/icons/Flag';
// import DeleteIcon from '@material-ui/icons/Delete';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import cyan from '@material-ui/core/colors/cyan';
import pink from '@material-ui/core/colors/pink';
import red from '@material-ui/core/colors/red';
import { useHistory } from "react-router-dom";
import validator from 'validator'

// import red from '@material-ui/core/colors/red';
import axios from 'axios';
// import ReactToPrint from 'react-to-print';
import './Label.css';
import Header from './Header'
const cookies = new Cookies();

const useStyles = makeStyles((theme) => ({
  '@global':{
    body:{
      backgroundColor:"#e2dedf",
    }
  },
  title: {

  },
  subTitle:{
    fontWeight: "normal"
  },
  root: {
    backgroundColor:"#e2dedf",
    flexGrow: 1,
    padding: theme.spacing(2),

    textAlign: 'center',
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
      // width: '40ch',
    },
    '&$required': {
      color: 'white'
    }
  },
  textField: {
    fontSize: 50, //works!

    '& p':{
      color: red[600],
    }
  },
      formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  menuButton: {
    marginLeft: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  button: {
    margin: theme.spacing(1)
  },
  paper: {
    backgroundColor:"#e2dedf",
    padding: theme.spacing(2),
    textAlign: 'center',
  },
  busy: {
    textAlign: 'center',
    padding: theme.spacing(2),
    '& > * + *': {
      marginLeft: theme.spacing(2),
    },
  }
}));
const theme = createMuiTheme({
  direction: 'rtl',
  palette: {
    primary: {
      main: pink[400],
    },
    secondary: {
      main: pink[200],
    },
    inherit: {
      main: cyan[200],
    },
  },
});
export default function LocalQR() {
  

  // const API_URL = "http://37.139.28.173:5000"
  const classes = useStyles();
  const [fullName, setFullName] = React.useState('');
  const [phoneError, setPhoneError] = React.useState('');
  const [id, setId] = React.useState(null);
  const [idError, setIdError] = React.useState('');
  const [phone, setPhone] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [emailError, setEmailError] = React.useState('');
  const [date, setDate] = React.useState(null);
  const [gender, setGender] = React.useState('');
  const [agrement, setAgrement] = React.useState(false);
  const [started, setStarted] = React.useState(false);
  const [busy, setBusy] = React.useState(false);
  // const hash = new URLSearchParams(this.props.location.search).get("__firebase_request_key")
  const API_URL = "https://gw-clubadm.euro-sport.co.il"
  const handleStart = (event) => {
    setStarted(true)
    if (validateInputs()){
      setBusy(true)
      axios.post(API_URL+'/new_invite_sms',{
        agent:8503080,
        phone:phone
      })
      .then(function (response) {
        if(response.status === 200){
          window.location.href = "/invited";
        }
        else{
          window.location.href = "/failed";
        }

      })
      .catch(function (error) {
        setBusy(false)
      });
      setBusy(false)

    }
    // axios.post(API_URL+'/new_invite_sms',{
    //   agent:worker.id,phone:phone
    // })
    // .then(function (response) {

    // })
    // .catch(function (error) {
    //     console.log(error);
    // });
    // setDetails(event.target.checked);
  };
  const handleCancel = (event) => {
    // setPhone('')
    setFullName('')
    setId('')
    setDate(null)
    setEmail('')
    setGender('')
    setAgrement(false)
  }
  const validateInputs = () => {
    if(phone && agrement){
      return true;
    }
    else {

      if(!phone){
        setPhoneError('שדה חובה')
      }
    }
  }
    const handleInput = (event) => {
      switch(event.target.id){
        case 'phone':
          setPhone(event.target.value)
        break;
        case 'agrement':
          setAgrement(!agrement)
        break;
      }
        // setPhone(event.target.value)
    }

  return (
    <ThemeProvider theme={theme}>
    <div className={classes.root}>
      <img src='logo.png' height='40px'/>

            <form className={classes.root} autoComplete="off">
              <h3 className={classes.title}>הגיע הזמן שנהיה חברים</h3>
              <h4 className={classes.subTitle}>יש להזין מספר טלפון כדי להתחיל</h4>
                
                <div>
                  <TextField id="phone" type="number" value={phone} label="מספר טלפון" required={true} onChange={handleInput}/>
                </div>
<FormControl error={!agrement && started} >
  <FormControlLabel
                      control={<Checkbox id="agrement"  color='primary' checked={agrement} name="checkedA" onChange={handleInput} />}
                      label='הנני מאשר/ת את תקנון ההצטרפות למועדון הלקוחות וקבלת מבצעים וחומר שיווקי במייל ובסמס מיורוספורט בע"מ. מתחייבים שלא להעביר את פרטיך לצד שלישי'/>
  {!agrement && started && <FormHelperText>עלייך לאשר את התקנון</FormHelperText>}
</FormControl>

                {/* <div><TextField id="outlined-basic" type="number" InputLabelProps={{ shrink: true }} label="מגדר" required={true} onChange={handleInput}/></div> */}
                {phone && phone.length === 10 && ([
                // {fullName && phone && agrement && checkId(id) && validator.isEmail(email) && ([
                  <div>     
                    <Button variant="contained" color="primary" className={classes.button} disabled={busy} onClick={handleStart}>שלח</Button>
                  </div>
                 ])}
            </form>
            
        {/* </Paper> */}
        
    </div>
        {/* </div> */}

  </ThemeProvider>
  );
}
